// Hot Peppers - Ranked by Scoville Heat Units (SHU)
export const HOT_PEPPERS_CARDS = [
  { id: 1, name: "Pepper X", rank: 1, image: "/images/hotPeppers/pepper_x.png" },
  { id: 2, name: "Carolina Reaper", rank: 2, image: "/images/hotPeppers/carolina_reaper.png" },
  { id: 3, name: "Komodo Dragon", rank: 3, image: "/images/hotPeppers/komodo_dragon.png" },
  { id: 4, name: "Trinidad Scorpion", rank: 4, image: "/images/hotPeppers/trinidad_scorpion.png" },
  { id: 5, name: "7 Pot Douglah", rank: 5, image: "/images/hotPeppers/7_pot_douglah.png" },
  { id: 6, name: "Naga Viper", rank: 6, image: "/images/hotPeppers/naga_viper.png" },
  { id: 7, name: "Ghost Pepper", rank: 7, image: "/images/hotPeppers/ghost_pepper.png" },
  { id: 8, name: "Red Savina", rank: 8, image: "/images/hotPeppers/red_savina.png" },
  { id: 9, name: "Scotch Bonnet", rank: 9, image: "/images/hotPeppers/scotch_bonnet.png" },
  { id: 10, name: "Habanero", rank: 10, image: "/images/hotPeppers/habanero.png" },
  { id: 11, name: "Bird's Eye", rank: 11, image: "/images/hotPeppers/birds_eye.png" },
  { id: 12, name: "Cayenne", rank: 12, image: "/images/hotPeppers/cayenne.png" },
  { id: 13, name: "Tabasco", rank: 13, image: "/images/hotPeppers/tabasco.png" },
  { id: 14, name: "Serrano", rank: 14, image: "/images/hotPeppers/serrano.png" },
  { id: 15, name: "Jalapeño", rank: 15, image: "/images/hotPeppers/jalapeno.png" },
  { id: 16, name: "Chipotle", rank: 16, image: "/images/hotPeppers/chipotle.png" },
  { id: 17, name: "Poblano", rank: 17, image: "/images/hotPeppers/poblano.png" },
  { id: 18, name: "Anaheim", rank: 18, image: "/images/hotPeppers/anaheim.png" },
  { id: 19, name: "Pepperoncini", rank: 19, image: "/images/hotPeppers/pepperoncini.png" },
  { id: 20, name: "Banana Pepper", rank: 20, image: "/images/hotPeppers/banana_pepper.png" },
  { id: 21, name: "Pimento", rank: 21, image: "/images/hotPeppers/pimento.png" },
  { id: 22, name: "Shishito", rank: 22, image: "/images/hotPeppers/shishito.png" },
  { id: 23, name: "Cubanelle", rank: 23, image: "/images/hotPeppers/cubanelle.png" },
  { id: 24, name: "Bell Pepper", rank: 24, image: "/images/hotPeppers/bell_pepper.png" }
];
